'use strict';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var compareCell = require('compare-cell');

var compareOrientedCell = require('compare-oriented-cell');

var orientation = require('cell-orientation');

module.exports = reduceCellComplex;

function reduceCellComplex(cells) {
  cells.sort(compareOrientedCell);
  var n = cells.length;
  var ptr = 0;

  for (var i = 0; i < n; ++i) {
    var c = cells[i];
    var o = orientation(c);

    if (o === 0) {
      continue;
    }

    if (ptr > 0) {
      var f = cells[ptr - 1];

      if (compareCell(c, f) === 0 && orientation(f) !== o) {
        ptr -= 1;
        continue;
      }
    }

    cells[ptr++] = c;
  }

  cells.length = ptr;
  return cells;
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(reduceCellComplex, "reduceCellComplex", "/home/yatham/Dev_BHS_Portal/node_modules/reduce-simplicial-complex/reduce.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();